export interface IApplicationState {

    transitionBalance: any;
    previousBalance: any;
    betList: any;
    winAmountEmpty: any;
    totalCreditWinAmount: any;
    fgSpinWinAmount: any;
    totalWinAmount: any;
    scatterDataBeforeFG: any;
    scatterDataAnticipation: any;
    resetMultiWaysTextToInitial: any;
    storeAmountForAutoplay: any;
    showSettingGameRules: any;
    showBetHistory: any;
    showGameSettings: any;
    menuBtnClicked: any;
    displayInCoins: any;
    autoplayList: any;
    disableBuyIn: boolean;
    outroBannerSkipped: boolean;
    showBuyFeature: boolean;
    buyInFeatureDeductAmt: number;
    buyFeatureAmountArr: any;
    landingSymbolSoundArr: any;
    blastSymbolSoundArr: any
    insufficientFunds: boolean
    buyFeatureStakeExceeds: boolean
    buyFeatureMaxStake: any
    blockLayer: boolean
    sessionTimer: any,
    hasCapped: boolean,
    cappedAmount: number,
    updateMultiplierForBuyFeature: boolean,
    addOnBalance: number,
    hasBalance: boolean,


}

const initialState: IApplicationState = {
    transitionBalance: 0,
    previousBalance: 0,
    betList: [],
    winAmountEmpty: false,
    totalCreditWinAmount: 0,
    fgSpinWinAmount: 0,
    totalWinAmount: 0,
    buyFeatureMaxStake: 0,
    buyInFeatureDeductAmt: 0,
    scatterDataBeforeFG: [],
    scatterDataAnticipation: [],
    buyFeatureAmountArr: [],
    disableBuyIn: false,
    resetMultiWaysTextToInitial: false,
    storeAmountForAutoplay: 0,
    showSettingGameRules: false,
    showBetHistory: false,
    showGameSettings: false,
    menuBtnClicked: false,
    displayInCoins: false,
    outroBannerSkipped: false,
    showBuyFeature: false,
    insufficientFunds: false,
    buyFeatureStakeExceeds: false,
    blockLayer: false,
    autoplayList: [],
    landingSymbolSoundArr: [],
    blastSymbolSoundArr: [],
    sessionTimer: 0,
    hasCapped: false,
    cappedAmount: 0,
    updateMultiplierForBuyFeature: false,
    addOnBalance: 0,
    hasBalance: false,
};

export enum actionTypes {

    SET_HAS_CAPPED = '@@behaviour/SET_HAS_CAPPED',
    SET_CAPPED_AMOUNT = '@@behaviour/SET_CAPPED_AMOUNT',
    SET_TRANSITION_BALANCE = '@@behaviour/SET_TRANSITION_BALANCE',
    SET_PREVIOUS_BALANCE = '@@behaviour/SET_PREVIOUS_BALANCE',
    SET_BET_LIST = '@@behaviour/SET_BET_LIST',
    SET_SCATTER_DATA_BEFORE_FG = '@@behaviour/SET_SCATTER_DATA_BEFORE_FG',
    SET_SCATTER_DATA_ANTICIPATION = '@@behaviour/SET_SCATTER_DATA_ANTICIPATION',
    SET_WIN_AMOUNT_EMPTY = '@@behaviour/SET_WIN_AMOUNT_EMPTY',
    SET_TOTAL_CREDITED_WIN_AMOUNT = '@@behaviour/SET_TOTAL_CREDITED_WIN_AMOUNT',
    SET_FG_CREDITED_WIN_AMOUNT = '@@behaviour/SET_FG_CREDITED_WIN_AMOUNT',
    SET_TOTAL_WIN_AMOUNT = '@@behaviour/SET_TOTAL_WIN_AMOUNT',
    RESET_INITIAL_MULTIWAYS_TEXT = '@@behaviour/RESET_INITIAL_MULTIWAYS_TEXT',
    STORE_AMOUNT_FOR_AUTOPLAY = '@@behaviour/STORE_AMOUNT_FOR_AUTOPLAY',
    SHOW_SETTING_GAME_RULES = '@@behaviour/SHOW_SETTING_GAME_RULES',
    SHOW_BET_HISTORY = '@@behaviour/SHOW_BET_HISTORY',
    SHOW_GAME_SETTINGS = '@@behaviour/SHOW_GAME_SETTINGS',
    DISPLAY_IN_COINS = '@@behaviour/DISPLAY_IN_COINS',
    OUTRO_BANNER_SKIPPED = '@@behaviour/OUTRO_BANNER_SKIPPED',
    MENU_BUTTON_CLICKED = '@@behaviour/MENU_BUTTON_CLICKED',
    SHOW_BUY_FEATURE = '@@behaviour/SHOW_BUY_FEATURE',
    SET_BUY_FEATURE_AMOUNT = '@@behaviour/SET_BUY_FEATURE_AMOUNT',
    SET_BUY_FEATURE_MAX_STAKE = '@@behaviour/SET_BUY_FEATURE_MAX_STAKE',
    DISABLE_BUYIN = '@@behaviour/DISABLE_BUYIN',
    SET_AUTOPLAY_LIST = '@@behaviour/SET_AUTOPLAY_LIST',
    SET_LANDING_SYMBOL_SOUNDS = '@@behaviour/SET_LANDING_SYMBOL_SOUNDS',
    SET_BLAST_SYMBOL_SOUNDS = '@@behaviour/SET_BLAST_SYMBOL_SOUNDS',
    SET_BUYIN_FEATURE_DEDUCT_AMT = '@@behaviour/SET_BUYIN_FEATURE_DEDUCT_AMT',
    SET_INSUFFICIENT_FUNDS = '@@behaviour/SET_INSUFFICIENT_FUNDS',
    SET_BUY_FEATURE_STAKE_EXCEEDS = '@@behaviour/SET_BUY_FEATURE_STAKE_EXCEEDS',
    SET_BLOCK_LAYER = '@@behaviour/SET_BLOCK_LAYER',
    SET_SESSION_TIMER = '@@behaviour/SET_SESSION_TIMER',
    SET_MULTIPLIER_VALUE_FOR_BUY_FEATURE = '@@behaviour/SET_MULTIPLIER_VALUE_FOR_BUY_FEATURE',
    STORE_ADD_ON_AMOUNT_AFTER_FREE_GAME = '@@behaviour/STORE_ADD_ON_AMOUNT_AFTER_FREE_GAME',
    SET_BALANCE_MANAULY = '@@behaviour/SET_BALANCE_MANAULY',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { hasBalance, transitionBalance, previousBalance, buyInFeatureDeductAmt, fgSpinWinAmount, buyFeatureStakeExceeds, buyFeatureMaxStake,
        betList, storeAmountForAutoplay, winAmountEmpty, showBetHistory, showGameSettings, menuBtnClicked, showBuyFeature, landingSymbolSoundArr, buyFeatureAmount,
        totalCreditWinAmount, totalWinAmount, scatterDataBeforeFG, showSettingGameRules, displayInCoins, outroBannerSkipped, blastSymbolSoundArr, insufficientFunds,
        hasCappedAction, cappedAmountAction, resetMultiWaysTextToInitial, scatterDataAnticipationAction, autoplayList, blocklayer, sessionTimerAction, disableBuyIn
        , updateMultiplierForBuyFeature, addOnBalance } = action;

    switch (action.type) {

        case actionTypes.SET_HAS_CAPPED:
            return {
                ...state, hasCapped: hasCappedAction,
            };
        case actionTypes.SET_CAPPED_AMOUNT:
            return {
                ...state, cappedAmount: cappedAmountAction,
            };
        case actionTypes.SET_SESSION_TIMER:
            return {
                ...state, sessionTimer: sessionTimerAction,
            };
        case actionTypes.SET_BUYIN_FEATURE_DEDUCT_AMT:
            return {
                ...state, buyInFeatureDeductAmt: buyInFeatureDeductAmt,
            };
        case actionTypes.SET_TRANSITION_BALANCE:
            return {
                ...state, transitionBalance: transitionBalance,
            };
        case actionTypes.STORE_AMOUNT_FOR_AUTOPLAY:
            return {
                ...state, storeAmountForAutoplay: storeAmountForAutoplay,
            };
        case actionTypes.SET_PREVIOUS_BALANCE:
            return {
                ...state, previousBalance: previousBalance,
            };
        case actionTypes.SET_BET_LIST:
            return {
                ...state, betList: betList,
            };
        case actionTypes.SET_WIN_AMOUNT_EMPTY:
            return {
                ...state, winAmountEmpty: winAmountEmpty,
            };
        case actionTypes.SET_TOTAL_CREDITED_WIN_AMOUNT:
            return {
                ...state, totalCreditWinAmount: totalCreditWinAmount,
            };
        case actionTypes.SET_FG_CREDITED_WIN_AMOUNT:
            return {
                ...state, fgSpinWinAmount: fgSpinWinAmount,
            };
        case actionTypes.SET_TOTAL_WIN_AMOUNT:
            return {
                ...state, totalWinAmount: totalWinAmount,
            };
        case actionTypes.SHOW_SETTING_GAME_RULES:
            return {
                ...state, showSettingGameRules: showSettingGameRules,
            };
        case actionTypes.SHOW_GAME_SETTINGS:
            return {
                ...state, showGameSettings: showGameSettings,
            };
        case actionTypes.MENU_BUTTON_CLICKED:
            return {
                ...state, menuBtnClicked: menuBtnClicked,
            };
        case actionTypes.SHOW_BUY_FEATURE:
            return {
                ...state, showBuyFeature: showBuyFeature,
            };
        case actionTypes.SET_INSUFFICIENT_FUNDS:
            return {
                ...state, insufficientFunds: insufficientFunds,
            };
        case actionTypes.SET_BUY_FEATURE_STAKE_EXCEEDS:
            return {
                ...state, buyFeatureStakeExceeds: buyFeatureStakeExceeds,
            };
        case actionTypes.SET_BUY_FEATURE_AMOUNT:
            return {
                ...state, buyFeatureAmountArr: buyFeatureAmount, buyFeatureMaxStake: buyFeatureMaxStake
            };
        case actionTypes.SET_BUY_FEATURE_MAX_STAKE:
            return {
                ...state, buyFeatureMaxStake: buyFeatureMaxStake
            };
        case actionTypes.DISABLE_BUYIN:
            return {
                ...state, disableBuyIn: disableBuyIn
            };
        case actionTypes.DISPLAY_IN_COINS:
            return {
                ...state, displayInCoins: displayInCoins,
            };
        case actionTypes.OUTRO_BANNER_SKIPPED:
            return {
                ...state, outroBannerSkipped: outroBannerSkipped,
            };
        case actionTypes.SHOW_BET_HISTORY:
            return {
                ...state, showBetHistory: showBetHistory,
            };
        case actionTypes.RESET_INITIAL_MULTIWAYS_TEXT:
            return {
                ...state, resetMultiWaysTextToInitial: resetMultiWaysTextToInitial,
            };
        case actionTypes.SET_SCATTER_DATA_BEFORE_FG:
            return {
                ...state, scatterDataBeforeFG: scatterDataBeforeFG,
            };
        case actionTypes.SET_SCATTER_DATA_ANTICIPATION:
            return {
                ...state, scatterDataAnticipation: scatterDataAnticipationAction,
            };

        case actionTypes.SET_AUTOPLAY_LIST:
            return {
                ...state, autoplayList: autoplayList,
            };
        case actionTypes.SET_LANDING_SYMBOL_SOUNDS:
            return {
                ...state, landingSymbolSoundArr: landingSymbolSoundArr,
            };
        case actionTypes.SET_BLAST_SYMBOL_SOUNDS:
            return {
                ...state, blastSymbolSoundArr: blastSymbolSoundArr,
            };
        case actionTypes.SET_BLOCK_LAYER:
            return {
                ...state, blockLayer: blocklayer,
            };
        case actionTypes.SET_MULTIPLIER_VALUE_FOR_BUY_FEATURE:
            return {
                ...state, updateMultiplierForBuyFeature: updateMultiplierForBuyFeature,
            };
        case actionTypes.STORE_ADD_ON_AMOUNT_AFTER_FREE_GAME:
            return {
                ...state, addOnBalance: addOnBalance,
            };

        case actionTypes.SET_BALANCE_MANAULY:
            return {
                ...state, hasBalance: hasBalance,
            };
        default:
            return state;
    }
}

export const actions = {

    hasBalanceOrEmpty: (hasBalance: boolean): any => ({
        type: actionTypes.SET_BALANCE_MANAULY,
        hasBalance
    }),

    amountAddedAfterFreeGame: (addOnBalance: number): any => ({
        type: actionTypes.STORE_ADD_ON_AMOUNT_AFTER_FREE_GAME,
        addOnBalance
    }),

    setMultiplierForBuyFeature: (updateMultiplierForBuyFeature: any): any => ({
        type: actionTypes.SET_MULTIPLIER_VALUE_FOR_BUY_FEATURE,
        updateMultiplierForBuyFeature
    }),

    setHasCapped: (hasCappedAction: any): any => ({
        type: actionTypes.SET_HAS_CAPPED,
        hasCappedAction
    }),
    setCappedAmount: (cappedAmountAction: any): any => ({
        type: actionTypes.SET_CAPPED_AMOUNT,
        cappedAmountAction
    }),
    setSessionTimer: (sessionTimerAction: any): any => ({
        type: actionTypes.SET_SESSION_TIMER,
        sessionTimerAction
    }),
    setBuyInFeatureAmtDeduct: (buyInFeatureDeductAmt: any): any => ({
        type: actionTypes.SET_BUYIN_FEATURE_DEDUCT_AMT,
        buyInFeatureDeductAmt
    }),
    setTransitionBalance: (transitionBalance: any): any => ({
        type: actionTypes.SET_TRANSITION_BALANCE,
        transitionBalance
    }),
    setAmountForAutoplay: (storeAmountForAutoplay: any): any => ({
        type: actionTypes.STORE_AMOUNT_FOR_AUTOPLAY,
        storeAmountForAutoplay
    }),
    setBlockLayer: (blocklayer: any): any => ({ type: actionTypes.SET_BLOCK_LAYER, blocklayer }),
    setPreviousBalance: (previousBalance: any): any => ({ type: actionTypes.SET_PREVIOUS_BALANCE, previousBalance }),
    setBetList: (betList: any): any => ({ type: actionTypes.SET_BET_LIST, betList }),
    setWinAmount: (winAmountEmpty: any): any => ({ type: actionTypes.SET_WIN_AMOUNT_EMPTY, winAmountEmpty }),
    setTotalCreditWinAmount: (totalCreditWinAmount: any): any => ({
        type: actionTypes.SET_TOTAL_CREDITED_WIN_AMOUNT,
        totalCreditWinAmount
    }),
    setFGCreditWinAmount: (fgSpinWinAmount: any): any => ({
        type: actionTypes.SET_FG_CREDITED_WIN_AMOUNT,
        fgSpinWinAmount
    }),
    setTotalWinAmount: (totalWinAmount: any): any => ({ type: actionTypes.SET_TOTAL_WIN_AMOUNT, totalWinAmount }),
    setOutroBannerSkip: (outroBannerSkipped: any): any => ({ type: actionTypes.OUTRO_BANNER_SKIPPED, outroBannerSkipped }),
    setDisplayInCoins: (displayInCoins: any): any => ({ type: actionTypes.DISPLAY_IN_COINS, displayInCoins }),
    showSettingGameRules: (showSettingGameRules: any): any => ({ type: actionTypes.SHOW_SETTING_GAME_RULES, showSettingGameRules }),
    setShowGameSettings: (showGameSettings: any): any => ({ type: actionTypes.SHOW_GAME_SETTINGS, showGameSettings }),
    setMenuButtonClicked: (menuBtnClicked: any): any => ({ type: actionTypes.MENU_BUTTON_CLICKED, menuBtnClicked }),
    setBuyFeatureClicked: (showBuyFeature: any): any => ({ type: actionTypes.SHOW_BUY_FEATURE, showBuyFeature }),
    setInsufficientFunds: (insufficientFunds: any): any => ({ type: actionTypes.SET_INSUFFICIENT_FUNDS, insufficientFunds }),
    setBuyFeatureStakeExceeds: (buyFeatureStakeExceeds: any): any => ({ type: actionTypes.SET_BUY_FEATURE_STAKE_EXCEEDS, buyFeatureStakeExceeds }),
    setBuyFeatureAmount: (buyFeatureAmount: any): any => ({ type: actionTypes.SET_BUY_FEATURE_AMOUNT, buyFeatureAmount }),
    setBuyFeatureMaxStake: (buyFeatureMaxStake: any): any => ({ type: actionTypes.SET_BUY_FEATURE_MAX_STAKE, buyFeatureMaxStake }),
    setDisableBuyIn: (disableBuyIn: any): any => ({ type: actionTypes.DISABLE_BUYIN, disableBuyIn }),
    showBetHistory: (showBetHistory: any): any => ({ type: actionTypes.SHOW_BET_HISTORY, showBetHistory }),
    setScatterDataBeforeFG: (scatterDataBeforeFG: any): any => ({ type: actionTypes.SET_SCATTER_DATA_BEFORE_FG, scatterDataBeforeFG }),
    setScatterDataAnticipation: (scatterDataAnticipationAction: any): any => ({ type: actionTypes.SET_SCATTER_DATA_ANTICIPATION, scatterDataAnticipationAction }),
    resetMultiwaysValue: (resetMultiWaysTextToInitial: any): any => ({ type: actionTypes.RESET_INITIAL_MULTIWAYS_TEXT, resetMultiWaysTextToInitial }),
    setAutoplayList: (autoplayList: any): any => ({ type: actionTypes.SET_AUTOPLAY_LIST, autoplayList }),
    setLandingSymbolSoundsArr: (landingSymbolSoundArr: any): any => ({ type: actionTypes.SET_LANDING_SYMBOL_SOUNDS, landingSymbolSoundArr }),
    setBlastSymbolSoundsArr: (blastSymbolSoundArr: any): any => ({ type: actionTypes.SET_BLAST_SYMBOL_SOUNDS, blastSymbolSoundArr }),

};